<template>
  <div>
    <v-btn v-if="$store.state.lastRoute.name === 'login'" @click="goBack" icon>
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-divider></v-divider>
    <v-container fluid>
      <v-card flat>
        <v-card-text style="overflow-x: auto" v-html="terms.text"></v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      terms: ({ terms }) => terms.terms,
      status: ({ terms }) => terms.status,
    }),
  },
  methods: {
    ...mapActions("terms", ["getTerms"]),
    initData() {
      this.getTerms({});
    },
    goBack() {
      const lastRoute = this.$store.state.lastRoute;
      if (lastRoute) {
        this.$router.push(lastRoute);
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
  watch: {
    "$route.query.lang"(val) {
      this.initData();
    },
  },
};
</script>
